import { render, staticRenderFns } from "./detailFundingAgencyTrainings.vue?vue&type=template&id=1a9faa6e&scoped=true"
import script from "./detailFundingAgencyTrainings.vue?vue&type=script&lang=js"
export * from "./detailFundingAgencyTrainings.vue?vue&type=script&lang=js"
import style0 from "./detailFundingAgencyTrainings.vue?vue&type=style&index=0&id=1a9faa6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9faa6e",
  null
  
)

export default component.exports